import { Heart, ShieldCheck, Smile } from "lucide-react";

export default function About({ content }) {
  const sec = content?.about || {};
  const stats = sec.stats || [];

  return (
    <section id="sobre" className="relative py-20 md:py-28 bg-cream" data-testid="about-section">
      <div className="max-w-6xl mx-auto px-5 md:px-8 text-center">
        <span className="inline-block font-display text-sm font-semibold tracking-[0.2em] uppercase mb-4" style={{ color: "var(--ff-peach)" }}>
          {sec.eyebrow || "Sobre Nós"}
        </span>
        <h2 className="title-pop text-4xl md:text-5xl mb-6 max-w-3xl mx-auto" style={{ color: "var(--ff-text)" }}>
          {sec.title}
        </h2>
        <p className="max-w-2xl mx-auto text-base md:text-lg font-body leading-relaxed mb-12" style={{ color: "var(--ff-text-soft)" }}>
          {sec.body}
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
          {stats.map((s, i) => {
            const Icon = [Heart, Smile, ShieldCheck][i % 3];
            return (
              <div
                key={i}
                className="hover-zoom rounded-3xl p-8 border-4 bg-white"
                style={{ borderColor: i % 2 === 0 ? "var(--ff-peach)" : "var(--ff-sky)" }}
                data-testid={`about-stat-${i}`}
              >
                <Icon size={32} className="mx-auto mb-3" style={{ color: i % 2 === 0 ? "var(--ff-peach)" : "var(--ff-sky)" }} />
                <div className="title-pop text-4xl md:text-5xl mb-1" style={{ color: "var(--ff-text)" }}>
                  {s.number}
                </div>
                <div className="font-body text-base font-medium" style={{ color: "var(--ff-text-soft)" }}>
                  {s.label}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
